import styled from "styled-components";

export const Svg = styled.svg`
  margin-left: 8px;
  margin-bottom: 2px;
  justify-content: center;
  align-items: center;
`;
